import { useState } from 'react';
import { AuthBackLink } from '@/components/auth/AuthBackLink';
import { AuthTabSwitcher } from '@/components/auth/AuthTabSwitcher';
import { AuthMobileLayout, AuthDesktopLayout } from '@/components/auth/AuthLayouts';

export default function LoginPage() {
  const [activeTab, setActiveTab] = useState<'login' | 'register'>('login');
  const backToHome = <AuthBackLink to="/" label="Halaman Utama" />;

  return (
    <>
      <div className="block lg:hidden" data-testid="auth-mobile-section">
        <AuthMobileLayout backLink={backToHome}>
          <AuthTabSwitcher value={activeTab} onValueChange={setActiveTab} />
        </AuthMobileLayout>
      </div>
      <div className="hidden lg:block" data-testid="auth-desktop-section">
        <AuthDesktopLayout>
          <AuthTabSwitcher value={activeTab} onValueChange={setActiveTab} />
        </AuthDesktopLayout>
      </div>
    </>
  );
}
